import React from 'react'
import Icon from '../../icon/icon.component'
import * as Styles from './item.styles'

type Props = {
  active: boolean
  icon: string[]
  text: string
  to: string
  visible: boolean
}

const Item: React.FC<any> = (props: Props) => {
  return (
    <Styles.Item active={props.active}>
      <Styles.Link href={props.to}>
        <Styles.Icon>
          <Icon icon={props.icon} />
        </Styles.Icon>
        <Styles.Text>{props.text}</Styles.Text>
      </Styles.Link>
    </Styles.Item>
  )
}

export default Item
